import React from 'react';

class CookieDisclaimer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };

        this.accept = this.accept.bind(this);
    }

    componentDidMount() {
        const accepted = localStorage.getItem('cookieAccepted');
        if (!accepted) {
            this.setState({ visible: true });
        }
    }

    accept() {
        localStorage.setItem('cookieAccepted', 'true');
        this.setState({ visible: false });
    }

    render() {
        if (!this.state.visible) return null;

        return (
            <div style={styles.overlay}>
                <div style={styles.box}>
                    {/*<h3>Utilizziamo cookie tecnici</h3>*/}
                    {/*<p>*/}
                        Questo sito utilizza solo cookie tecnici necessari al suo funzionamento.
                        Non usiamo cookie di profilazione o tracciamento.
                    {/*}</p>*/}
                    <button onClick={this.accept} style={styles.button}>
                        OK, ho capito
                    </button>
                </div>
            </div>
        );
    }
}

const styles = {
    overlay: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(0,0,0,0.6)',
        padding: '15px',
        zIndex: 9999
    },
    box: {
        background: 'black',
        color: 'whitesmoke',
        padding: '10px',
        borderRadius: '8px',
        maxWidth: '800px',
        margin: '0 auto',
        textAlign: 'center'
    },
    button: {
        marginTop: '15px',
        padding: '10px 20px',
        border: 'none',
        background: '#007bff',
        color: '#fff',
        borderRadius: '5px',
        cursor: 'pointer'
    }
};

export default CookieDisclaimer;